import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const MinaForfragningar = lazy(() => import("@/pages/mina-sidor/Forfragningar"));

export const Route = createFileRoute("/mina-sidor/forfragningar")({
  head: () => ({
    meta: [
      { title: "Förfrågningar » Mina sidor | Elmarknad.se" },
      { name: "description", content: "Följ dina elavtalsbyten och offertförfrågningar på ett ställe." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => <MinaForfragningar />,
});
